export default __webpack_public_path__ + "static/media/logo-bca.d0f3b48b.jpg";